import React, { useState, useEffect } from 'react'
import PlaceIcon from '@material-ui/icons/FiberManualRecord'
import GoogleMapReact from 'google-map-react'
import { circleConst } from '../Shared/constants'
import { mapShading } from '../Shared/constants'
import LargeViewModal from 'UI/LargeViewModal'
import * as jsts from 'jsts'
import { MapContainer, Container, StyledText, DriverInstructionsContainer } from './styles'

const { REACT_APP_GOOGLE_API_KEY } = process.env

const SiteViewModal = props => {
  const defaultMapProps = {
    center: {
      lat: 49.26,
      lng: -123.11
    },
    zoom: 20
  }

  const [mapProps, setMapProps] = useState({
    center: {},
    zoom: 15
  })

  const Marker = () => (
    <PlaceIcon
      style={{
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        color: 'red',
        width: '20px',
        height: '20px'
      }}
    />
  )

  const getMapOptions = maps => {
    return {
      streetViewControl: true,
      scaleControl: true,
      fullscreenControl: false,
      mapTypeId: maps.MapTypeId.ROADMAP,
      mapTypeControl: true,
      mapTypeControlOptions: {
        mapTypeIds: [maps.MapTypeId.ROADMAP, maps.MapTypeId.SATELLITE, maps.MapTypeId.HYBRID]
      },

      zoomControl: true,
      clickableIcons: false
    }
  }

  const polygonCoords2JTS = polygonCoords => {
    const jstsCoordinates = polygonCoords.map(pt => {
      return new jsts.geom.Coordinate(pt.lat, pt.lng)
    })
    jstsCoordinates.push(new jsts.geom.Coordinate(polygonCoords[0].lat, polygonCoords[0].lng))
    return jstsCoordinates
  }

  const apiLoaded = (map, maps) => {
    if (!map || !maps) {
      alert('Unknown error has occured. Please try again')
      window.location.reload()
    }
    if (
      props.siteViewDetail.customCoordinates &&
      props.siteViewDetail.customCoordinates.length > 0
    ) {
      const coordinates = polygonCoords2JTS(props.siteViewDetail.customCoordinates)
      const geometryFactory = new jsts.geom.GeometryFactory()
      const linearRing = geometryFactory.createLinearRing(coordinates)
      const { x, y } = linearRing.getCentroid()._coordinates._coordinates[0]
      const latLngCenter = {
        lat: x,
        lng: y
      }
      setMapProps({ center: latLngCenter })

      new maps.Polygon({
        paths: props.siteViewDetail.customCoordinates,
        ...mapShading,
        map
      })
    } else {
      const circle = {
        ...circleConst,
        map,
        center: mapProps.center,
        radius: props.siteViewDetail.radius * 1000
      }
      new maps.Circle(circle)
    }
  }

  const handleEditClick = () => {
    props.editSiteModalToggle(props.siteViewDetail._id)
  }

  useEffect(() => {
    const { lat, lng } = props.siteViewDetail.coordinates
    if (
      !props.siteViewDetail.customCoordinates ||
      (props.siteViewDetail.customCoordinates && props.siteViewDetail.customCoordinates.length > 0)
    ) {
      setMapProps({
        center: {
          lat,
          lng
        },
        zoom: 15
      })
    }
  }, [props.siteViewDetail.coordinates]) // eslint-disable-line

  return (
    <LargeViewModal
      title={props.siteViewDetail.siteName}
      subTitle={props.siteViewDetail.company}
      handleOkClick={props.siteViewModalToggle}
      handleEditClick={handleEditClick}
    >
      <Container>
        <StyledText>
          {props.siteViewDetail.type
            ? props.siteViewDetail.project
              ? `${props.siteViewDetail.project.projectName} Project Site`
              : `${props.siteViewDetail.type} Site`
            : ''}
        </StyledText>
        <MapContainer>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: REACT_APP_GOOGLE_API_KEY,
              libraries: ['drawing']
            }}
            defaultCenter={defaultMapProps.center}
            defaultZoom={defaultMapProps.zoom}
            center={mapProps.center}
            zoom={mapProps.zoom}
            yesIWantToUseGoogleMapApiInternals
            options={getMapOptions}
            onGoogleApiLoaded={({ map, maps }) => apiLoaded(map, maps)}
          >
            {!props.siteViewDetail.customCoordinates && (
              <Marker lat={mapProps.center.lat} lng={mapProps.center.lng} text="My Marker" />
            )}
          </GoogleMapReact>
        </MapContainer>
        {props.siteViewDetail.defaultInstructions && (
          <DriverInstructionsContainer>
            <StyledText>Driver Instructions - Default</StyledText>
            <StyledText>{props.siteViewDetail.defaultInstructions}</StyledText>
          </DriverInstructionsContainer>
        )}
      </Container>
    </LargeViewModal>
  )
}

export default SiteViewModal
